module.exports = __webpack_public_path__ + "static/media/LG_FilterTour_s4.c0d4a9d3.gif";